import React from 'react'

import { Pill } from 'sdk/pill/Pill'
import { Text, TextName } from 'sdk/text/Text'
import databaseGradientIcon from 'shared/assets/icons/database-gradient.svg'
import audioWaveIcon from 'shared/assets/icons/audio-wave.svg'
import microphoneIcon from 'shared/assets/icons/microphone.svg'

import type { SoundscapeShowcaseCmsContent } from 'core/services/cms/interfaces'

import { ShowcaseFeatureDisplay } from './ShowcaseFeatureDisplay'

import carIcon from '../../assets/car.svg'
import showcaseBackgroundDesktop from '../../assets/soundscape-showcase-background-desktop.jpg'
import showcaseBackgroundMobile from '../../assets/soundscape-showcase-background-mobile.jpg'

import styles from './ShowcaseSection.module.scss'

interface ShowcaseSectionProps {
  content: SoundscapeShowcaseCmsContent
}

const CARD_ICONS = [carIcon, audioWaveIcon, microphoneIcon]

const ShowcaseSection: React.FC<ShowcaseSectionProps> = ({ content }) => {
  return (
    <section className={styles.container}>
      <Pill
        text={content.pillText}
        icon={databaseGradientIcon}
        variant="gradient"
      />

      <Text
        type={TextName.H2}
        className={styles.title}
      >
        {content.title}
      </Text>

      <Text
        type={TextName.Text}
        className={styles.description}
      >
        {content.description}
      </Text>

      <ShowcaseFeatureDisplay
        desktopBackgroundUrl={showcaseBackgroundDesktop}
        mobileBackgroundUrl={showcaseBackgroundMobile}
        cards={content.cards.map((card, index) => ({ icon: CARD_ICONS[index], text: card.text }))}
      />
    </section>
  )
}

export default ShowcaseSection
